import { render, staticRenderFns } from "./DynamicFields.vue?vue&type=template&id=2d5e4d87&"
import script from "./DynamicFields.vue?vue&type=script&lang=js&"
export * from "./DynamicFields.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports